
import {TypeInt} from './../TypeDefinition'

function CodeHelpers (parser) {
    this.parser = parser
    this.pcode = this.parser.pcode
    this.scanner = this.parser.scanner
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
    this.outline = parser.outline
}

CodeHelpers.prototype = {
    codeVariableLoad (variableName, token) {
        if (token === undefined) {
            token = variableName
            variableName = token.lexema
        }
        token.procName = this.parser.currentProcName
        let type = this.stable.getStorage(variableName).getType()
        let displ = this.stable.getStorage(variableName).getDisplacement()

        if (!type.isArray() && !type.isReference()) {
            this.pcode.load(type, displ, token)
        } else if (type.isArray()) {
            this.pcode.loada(type, displ, token)
        } else if (type.isReference()) {
            this.pcode.loadi(type, displ, token)
        } else {
            console.log('Error al compilar codeVariableLoad')
        }
    },
    semanticsOpCast (op1, op2) {
        // dest <- source
        if (op1.eq(op2)) {
            return true
        }
        if (op1.isNumeric() && op2.isNumeric()) {
            return true
        }

        return false
    },
    codeAllocateVars (currentDispl) {
        let variables = this.stable.listVariables()
        let displ = currentDispl

        // Alloc para las variables
        for (let variable of variables) {
            let tokenVar = variable.getToken()
            tokenVar.procName = this.parser.currentProcName
            variable.setDisplacement(displ)
            if (variable.getType().isArray()) {
                this.pcode.push(variable.getType(), 1, tokenVar)
                this.pcode.alloca(variable.getType(), variable.getType().getSize(), tokenVar)
                this.pcode.store(variable.getType(), displ, tokenVar)
            } else {
                this.pcode.push(variable.getType(), variable.getType().getSize(), tokenVar)
            }
            if (this.outline[this.parser.currentProcName] !== undefined && this.outline[this.parser.currentProcName].variables[tokenVar.lexema] !== undefined) {
                this.outline[this.parser.currentProcName].variables[tokenVar.lexema].displacement = displ
            }
            displ += 1
        }
    },
    codeDeallocateVars (endToken) {
        let variables = this.stable.listVariables()
        let variable
        // Alloc para las variables
        for (let i = variables.length - 1; i >= 0; i--) {
            variable = variables[i]
            if (variable.getType().isArray()) {
                this.pcode.freea(variable.getType(), endToken)
                this.pcode.pop(variable.getType(), 1, endToken)
            } else {
                this.pcode.pop(variable.getType(), variable.getType().getSize(), endToken)
            }
        }
    },
    codeCopyVariable (identToken) {
        identToken.procName = this.parser.currentProcName
        let item = this.stable.getStorage(identToken.lexema)
        let newDisplacement = this.stable.getCurrentDisplacement()

        this.pcode.alloc(item.getType().clone(), item.getType().getSize(), identToken)
        this.stable.incrementDisplacement(item.getType().getSize())

        this.pcode.ldcte(new TypeInt(), item.getType().getSize(), identToken)

        this.pcode.cpmem(item.getDisplacement(), newDisplacement, identToken)

        return newDisplacement
    },
    codeReferenceLoad (asArray, type, identToken, displacement) {
        identToken.procName = this.parser.currentProcName
        if (asArray) {
            this.pcode.ldrefa(type, displacement, identToken)
        } else {
            this.pcode.ldref(type, displacement, identToken)
        }
    },
    semanticsAssignCast (dest, source) {
        // dest <- source
        if (dest.eq(source)) {
            return true
        }
        if (dest.isFloat() && source.isInt()) {
            return true
        }

        return false
    },
    codeStoreVar (variableName, token) {
        if (token === undefined) {
            token = variableName
            variableName = token.lexema
        }
        token.procName = this.parser.currentProcName
        let type = this.stable.getStorage(variableName).getType()
        let displ = this.stable.getStorage(variableName).getDisplacement()

        if (!type.isArray() && !type.isReference()) {
            this.pcode.store(type, displ, token)
        } else if (type.isArray()) {
            this.pcode.storea(type, displ, token)
        } else if (type.isReference()) {
            this.pcode.storei(type, displ, token)
        } else {
            console.log('Error al compilar codeStoreVar')
        }
    },
    codeAllocateParams (callableName) {
        let parameters = this.stable.listParameters()
        let displ = -parameters.length - 1

        //
        for (let parameter of parameters) {
            let tokenPar = parameter.getToken()
            tokenPar.procName = this.parser.currentProcName
            parameter.setDisplacement(displ)
            if (this.outline[this.parser.currentProcName] !== undefined && this.outline[this.parser.currentProcName].variables[tokenPar.lexema] !== undefined) {
                this.outline[this.parser.currentProcName].variables[tokenPar.lexema].displacement = displ
            }
            displ += parameter.getType().getSize()
        }
        return displ
    }
}

export default CodeHelpers



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/CodeHelpers.js